export default __webpack_public_path__ + "static/media/semicircle.6e86b02e.svg";